export default "__VITE_ASSET__DsGIZb1$__"